import numeral from 'numeral'
import getPriceAccuracy from './getPriceAccuracy'

/**
 * 得到符合最小变动单位的数值
 * @param {number} price - 价格
 * @param {number} tick - 最小变动单位
 * @param {boolean} toAccuracy - 强制转换小数位
 */
export default function getFixedPriceWithMinTick(
  price,
  tick,
  toAccuracy = false
) {
  if (!price || !tick) return price
  const value = numeral(
    ~~numeral(price)
      .divide(tick)
      .value()
  )
    .multiply(tick)
    .value()
  if (toAccuracy) {
    const accuracy = getPriceAccuracy(tick)
    return value.toFixed(accuracy)
  }
  return value
}
